import request from "@/utils/request";

//1,查询参赛队
export function getTeams(data){
    return request({
        url:'/admin/getTeams',
        data:data,
        method:'get'
    })
}
//1,删除参赛队
export function removeTeam(data){
    return request({
        url:'/admin/removeTeam',
        data:data,
        method:'post'
    })
}
//1,查询参赛队员
export function getMembers(data){
    return request({
        url:'/admin/getMembers',
        data:data,
        method:'get'
    })
}
//1,删除参赛队员
export function removeMember(data){
    return request({
        url:'/admin/removeMember',
        data:data,
        method:'post'
    })
}
//1,查询辅导老师
export function getTeachers(data){
    return request({
        url:'/admin/getTeachers',
        data:data,
        method:'get'
    })
}
//1,导出参赛队
export function exportTeams(data){
    return request({
        url:'/admin/exportTeams',
        data:data,
        method:'get'
    })
}
//1,导出参赛队员
export function exportMembers(data){
    return request({
        url:'/admin/exportMembers',
        data:data,
        method:'get'
    })
}
//1,导出辅导老师
export function exportTeachers(data){
    return request({
        url:'/admin/exportTeachers',
        data:data,
        method:'get'
    })
}
